import { ReactNode, forwardRef } from 'react';
import { Action, ActionFooter } from '../action-footer';
import { Popover } from './popover';
import { ClassNameOnlyProps } from '../../ozone-component';

interface Props extends ClassNameOnlyProps {
  title: ReactNode;
  confirmationText: ReactNode;
  ok: Action;
  cancel: Action;
  reverseCta?: boolean;
}

export const ConfirmationPopover = forwardRef<HTMLDivElement, Props>(
  ({ confirmationText, title, ok, cancel, reverseCta, className }, ref) => (
    <Popover className={className} ref={ref}>
      <Popover.Title data-cy="action-panel.confirmation-title">
        {title}
      </Popover.Title>
      <Popover.Content data-cy="action-panel.confirmation-text">
        {confirmationText}
      </Popover.Content>
      <Popover.Divider />
      <ActionFooter reverse={reverseCta} primary={ok} other={[cancel]} />
    </Popover>
  ),
);

ConfirmationPopover.displayName = 'ConfirmationPopover';
